import { Button, Col, Row } from 'react-bootstrap';
import { ITicket } from '../../commons/interfaces/ticket.interface';

interface IChatPaperHeaderProps {
  ticket: ITicket;
  onActionClick: () => void;
  managerId: string;
}

const ChatPaperHeader = ({ ticket, onActionClick, managerId }: IChatPaperHeaderProps) => {
  const canClickAction =
    ticket.status === 'WAITING' || (ticket.status !== 'CLOSED' && ticket.manager === managerId);

  const handleActionClick = () => {
    if (canClickAction) {
      onActionClick();
    }
  };

  return (
    <Row className="paper-header justify-content-between px-3 mt-3 mb-4">
      <Col className="paper-header-info" xs="auto">
        <b>Empresa:</b> {ticket.customer.business.name}
      </Col>
      <Col className="paper-header-actions" xs="auto">
        <b>Acción: </b>
        <Button
          onClick={handleActionClick}
          className="action-button"
          size="sm"
          variant="secondary"
          disabled={!canClickAction}>
          {ticket.status === 'WAITING'
            ? 'Ejecutar'
            : ticket.status === 'EXECUTING'
            ? 'Terminar'
            : 'Cerrado'}
        </Button>
      </Col>
    </Row>
  );
};

export default ChatPaperHeader;
